<template>
  <div class="w-100 mb-5">
    <div class="bs py-4 px-3 br8">
      <div class="d-flex align-items-center">
        <font-awesome-icon :icon="['far', 'sync-alt']" class="font24" />
        <p class="ml-2 font24 fw700 gray900">Synchronize your device</p>
      </div>
      <div class="device p-3 br8 d-flex align-items-center mt-4">
        <img src="../../../assets/images/fitbit.png" alt="fitbit" />
        <button
          :class="`br6 p1224 font14m12 fw700 ${fitbitAllowed ? 'gray600 no-click' : 'font-white'}`"
          :style="{ background: fitbitAllowed ? '#E2E8F0' : getPrimaryColor() }"
          @click="handleSync('fitbit')"
        >
          {{ fitbitAllowed ? "Synchronized" : "Synchronize" }}
        </button>
      </div>
      <div class="device p-3 br8 d-flex align-items-center mt-3">
        <img src="../../../assets/images/apple-health.png" alt="apple" />
        <button class="br6 p1224 font-white font14m12 fw700" :style="{ background: getPrimaryColor() }" @click="handleSync('apple')">{{ "Synchronize" }}</button>
      </div>
      <div class="device p-3 br8 d-flex align-items-center mt-3">
        <img src="../../../assets/images/g-health.png" alt="google" />
        <button
          :class="`br6 p1224 font14m12 fw700 ${gFitAllowed ? 'gray600 no-click' : 'font-white'}`"
          :style="{ background: gFitAllowed ? '#E2E8F0' : getPrimaryColor() }"
          @click="handleSync('google')"
        >
          {{ gFitAllowed ? "Synchronized" : "Synchronize" }}
        </button>
      </div>
    </div>

    <h3 class="fw700 font32 gray900 mt80">Trend</h3>
    <div class="d-flex align-items-center p-4 br8 font-white mt-3 dovedaily-mobile" :style="{ 'background-color': getSecondaryColor() }">
      <div class="d-flex flex-grow-1 align-items-center">
        <font-awesome-icon :icon="['fas', 'calendar-edit']" class="font20 font-white mr-4" />
        <div class="flex-grow-1 ml-2">
          <p class="mb-0 fw700 font-white">Update Your DoveDaily</p>
          <p v-if="dovedailyUpdatedAt" class="mb-0 font12 font-white">Last updated: {{ new Date(dovedailyUpdatedAt).toDateString().substring(4) }}</p>
        </div>
      </div>
      <div class="ml-4 br8 py-2 px-3 font12 fw700 cp hoverbg text-center" :style="{ 'background-color': getPrimaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">
        Update For Today
      </div>
    </div>

    <h1 class="bg-error50 error500 m-1 text-center p-2 br8 m-4">WIP</h1>

    <div class="bs p-4 br8 mt-5 mb-2">
      <div class="d-flex align-items-center flex-wrap">
        <h4 class="fw700 gray900 font24 flex-grow-1 m-w-100 m-mb16">Filter Trends</h4>
        <div
          class="br6 p1224 cp fw700 font14 trans"
          v-for="trend in filterTrends"
          :key="trend"
          :style="{ background: trend === activeFilterTab ? getPrimary50Color() : '#FFFFFF', color: trend === activeFilterTab ? getPrimaryColor() : '#0F1734' }"
          @click="() => (activeFilterTab = trend)"
        >
          {{ trend }}
        </div>
      </div>
      <div class="d-flex mt-4 gap10">
        <DatePicker
          v-model="selectedNewDate"
          type="date"
          v-if="activeFilterTab === 'Day'"
          class="w-100 dovedaily-new-datepicker"
          :append-to-body="false"
          :disabled-date="disabledDate"
          placeholder="Select Day"
        />
        <DatePicker
          v-model="selectedNewDate"
          :disabled-date="disabledDate"
          placeholder="Select Week"
          type="week"
          v-if="activeFilterTab === 'Week'"
          class="w-100 dovedaily-new-datepicker"
          :append-to-body="false"
        />
        <DatePicker
          v-model="selectedNewDate"
          :disabled-date="disabledDate"
          placeholder="Select Month"
          type="month"
          v-if="activeFilterTab === 'Month'"
          class="w-100 dovedaily-new-datepicker"
          :append-to-body="false"
        />
        <DatePicker
          placeholder="Select Year"
          :disabled-date="disabledDate"
          v-model="selectedNewDate"
          type="year"
          v-if="activeFilterTab === 'Year'"
          class="w-100 dovedaily-new-datepicker"
          :append-to-body="false"
        />
      </div>
    </div>

    <!-- One day value -->
    <template v-if="activeFilterTab === 'Day'">
      <div :style="{ 'min-height': '263px' }" class="gap16 d-flex justify-content-between mt32 m-flex-column">
        <div class="br8 bs flex1 p-4 d-flex flex-column">
          <div class="d-flex align-items-center">
            <h4 class="flex-grow-1 fw700 font24 gray900">Sleep</h4>
            <template v-if="avgVals.sleep">
              <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp font15" :style="{ color: getPrimary300Color() }" />
              <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300 font15" />
            </template>
          </div>
          <div
            v-if="avgVals.sleep"
            class="flex-center-center mx-auto mt-4 mh115"
            :style="{
              background: `conic-gradient(#00C853 0deg ${(avgVals.sleep / 24) * 360}deg, #CBD5E1 ${(avgVals.sleep / 24) * 360}deg 360deg)`,
              height: '137px',
              width: '137px',
              borderRadius: '50%',
            }"
          >
            <div class="flex-center-center font20 gray800 fw700 ar1" :style="{ height: '112px', borderRadius: '50%', background: 'white' }">{{ avgVals.sleep }}h</div>
          </div>
          <div v-else class="mt-4 bg-gray100 br8 p-4 flex1 flex-center-center flex-column">
            <p class="mb-3 gray700 font16 fw700">You have not updated your sleep yet.</p>
            <button
              class="py-2 px-3 br6 font-white font12 fw700 mx-auto"
              :style="{ backgroundColor: getSecondaryColor(), border: 'none', width: 'fit-content' }"
              @click="() => $router.push({ name: 'UpdateDoveDaily' })"
            >
              Update
            </button>
          </div>
        </div>

        <div class="br8 bs flex1 p-4 d-flex flex-column">
          <div class="d-flex align-items-center">
            <h4 class="flex-grow-1 fw700 font24 gray900">Mood</h4>
            <template v-if="oneDayData.mood">
              <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp font15" :style="{ color: getPrimary300Color() }" />
              <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300 font15" />
            </template>
          </div>
          <div v-if="oneDayData.mood" class="mt-4 br8 bg-gray100 d-flex align-items-center p-3 flex-column fw700 font20 justify-content-center mh115">
            <img src="../../../assets/emojis/happy-80.png" alt="emoji" class="hw80 ar1 mb-3" />
            {{ oneDayData.mood }}
          </div>
          <div v-else class="mt-4 bg-gray100 br8 p-4 flex1 flex-center-center flex-column">
            <p class="mb-3 gray700 font16 fw700">You have not updated your mood yet.</p>
            <button
              class="py-2 px-3 br6 font-white font12 fw700 mx-auto"
              :style="{ backgroundColor: getSecondaryColor(), border: 'none', width: 'fit-content' }"
              @click="() => $router.push({ name: 'UpdateDoveDaily' })"
            >
              Update
            </button>
          </div>
        </div>
      </div>

      <div :style="{ 'min-height': '241px' }" class="gap16 d-flex justify-content-between mt-5 m-flex-column">
        <div class="br8 bs flex1 d-flex flex-column p-4">
          <div class="d-flex align-items-center">
            <h4 class="flex-grow-1 fw700 font24 gray900">Heart Rate</h4>
            <template v-if="avgVals.heart">
              <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp font15" :style="{ color: getPrimary300Color() }" />
              <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300 font15" />
            </template>
          </div>
          <div v-if="avgVals.heart" class="mt-4 br8 bg-gray100 flex-center-center p-3 flex-column font18 gray700 flex-grow-1 mh115">
            <span class="font20 fw700 gray700">{{ avgVals.heart }}</span>
            BPM
          </div>
          <div v-else class="mt-4 bg-gray100 br8 p-4 flex1 flex-center-center flex-column">
            <p class="mb-3 gray700 font16 fw700">You have not updated your heart rate yet.</p>
            <button
              class="py-2 px-3 br6 font-white font12 fw700 mx-auto"
              :style="{ backgroundColor: getSecondaryColor(), border: 'none', width: 'fit-content' }"
              @click="() => $router.push({ name: 'UpdateDoveDaily' })"
            >
              Update
            </button>
          </div>
        </div>

        <div class="br8 bs flex1 d-flex flex-column p-4">
          <div class="d-flex align-items-baseline">
            <h4 class="flex-grow-1 fw700 font24 gray900">Body Temperature</h4>
            <template v-if="avgVals.temp">
              <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp font15" :style="{ color: getPrimary300Color() }" />
              <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300 font15" />
            </template>
          </div>
          <div v-if="avgVals.temp" class="mt-4 br8 bg-gray100 flex-center-center p-3 flex-column font20 fw700 gray700 flex-grow-1 mh115">{{ avgVals.temp }}°F</div>
          <div v-else class="mt-4 bg-gray100 br8 p-4 flex1 flex-center-center flex-column">
            <p class="mb-3 gray700 font16 fw700">You have not updated your temperature yet.</p>
            <button
              class="py-2 px-3 br6 font-white font12 fw700 mx-auto"
              :style="{ backgroundColor: getSecondaryColor(), border: 'none', width: 'fit-content' }"
              @click="() => $router.push({ name: 'UpdateDoveDaily' })"
            >
              Update
            </button>
          </div>
        </div>

        <div class="br8 bs flex1 d-flex flex-column p-4">
          <div class="d-flex align-items-center">
            <h4 class="flex-grow-1 fw700 font24 gray900">Weight</h4>
            <template v-if="avgVals.weight">
              <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp font15" :style="{ color: getPrimary300Color() }" />
              <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300 font15" />
            </template>
          </div>
          <div v-if="avgVals.weight" class="mt-4 br8 bg-gray100 flex-center-center p-3 flex-column font18 gray700 flex-grow-1 mh115">
            <span class="font20 fw700 gray700">{{ avgVals.weight }}</span>
            Lb
          </div>
          <div v-else class="mt-4 bg-gray100 br8 p-4 flex1 flex-center-center flex-column">
            <p class="mb-3 gray700 font16 fw700">You have not updated your weight yet.</p>
            <button
              class="py-2 px-3 br6 font-white font12 fw700 mx-auto"
              :style="{ backgroundColor: getSecondaryColor(), border: 'none', width: 'fit-content' }"
              @click="() => $router.push({ name: 'UpdateDoveDaily' })"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <!-- SLEEP -->
      <div class="bs p-4 br8 mt-4">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="fw700 font24 gray900">Sleep</h4>
          <h5 class="fw700 gray900 font20" v-if="avgVals.sleep">Avg. {{ avgVals.sleep }} {{ avgVals.sleep === 1 ? "hour" : "hours" }}</h5>
        </div>
        <!-- <LineGraph
          :chart-data="{
            labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            datasets: [
              {
                backgroundColor: 'rgba(200,219,245,0.5)',
                data: [6, 4, 8, 4, 6, 6, 8],
                fill: true,
                borderColor: ['rgba(200,219,245)'],
                pointBackgroundColor: '#A1BDE6',
                pointBorderWidth: 2,
                pointBorderColor: '#A1BDE6',
                tension: 0,
              },
            ],
          }"
          :options="{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    stepSize: 2,
                    beginAtZero: true,
                    userCallback(value, index, values) {
                      return `${value} hours`
                    },
                  },
                },
              ],
            },
            legend: { display: false },
          }"
        /> -->
        <div v-if="graphDataLoading" class="d-flex justify-content-center my-3">
          <div>
            <div class="spinner-border position-absolute spinner-class"></div>
          </div>
          <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading graph data...</div>
        </div>
        <div v-else class="position-relative">
          <LineGraph
            :chart-data="{
              labels: xAxisLabels,
              datasets: [
                {
                  backgroundColor: 'rgba(200,219,245,0.5)',
                  data: [6, 4, 8, 4, 6, 6, 8],
                  fill: true,
                  borderColor: ['rgba(200,219,245)'],
                  pointBackgroundColor: '#A1BDE6',
                  pointBorderWidth: 2,
                  pointBorderColor: '#A1BDE6',
                  tension: 0,
                },
              ],
            }"
            :options="{
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                yAxes: [
                  {
                    ticks: {
                      stepSize: 2,
                      beginAtZero: true,
                      userCallback(value, index, values) {
                        return `${value} hours`
                      },
                    },
                  },
                ],
              },
              legend: { display: false },
            }"
          />
          <h5 class="position-absolute abs-center mb-0 gray500 font20 p-2 bg-white" :style="{ top: '47%' }">No data Available</h5>
        </div>
        <p class="gray500 fw700 font18 mb-3 mt-4">My latest entries</p>
        <div class="bs br8 p12 d-flex align-items-center">
          <template v-if="latestVals.sleep">
            <div
              class="flex-center-center"
              :style="{
                background: `conic-gradient(#00C853 0deg ${(latestVals.sleep / 24) * 360}deg, #CBD5E1 ${(latestVals.sleep / 24) * 360}deg 360deg)`,
                height: '52px',
                width: '52px',
                borderRadius: '26px',
              }"
            >
              <div class="flex-center-center font12 gray900 fw700 ar1" :style="{ height: '42px', borderRadius: '50%', background: 'white' }">{{ latestVals.sleep }}h</div>
            </div>
            <p class="flex-grow-1 ml-3 font12 gray900">On: {{ new Date(latestDate.sleep).toDateString().substring(4) }}</p>
            <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp font15" :style="{ color: getPrimary300Color() }" />
            <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300 font15" />
          </template>
          <div v-else class="d-flex align-items-center justify-content-between w-100">
            <p class="mb-0 gray900 font12">You haven’t added any data yet</p>
            <button class="br6 px-3 py-2 font12 fw700 text-white" :style="{ 'background-color': getPrimaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">Add</button>
          </div>
        </div>
      </div>

      <!-- HEART RATE -->
      <div class="bs p-4 br8 mt80">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="fw700 font24 gray900">Heart Rate</h4>
          <h5 class="fw700 gray900 font20" v-if="avgVals.heart">Avg. {{ avgVals.heart }} bpm</h5>
        </div>
        <LineGraph
          :chart-data="{
            labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            datasets: [
              {
                backgroundColor: 'rgba(200,219,245,0.5)',
                data: [180, 170, 190, 170, 180, 180, 190],
                fill: true,
                borderColor: ['rgba(200,219,245)'],
                pointBackgroundColor: '#A1BDE6',
                pointBorderWidth: 2,
                pointBorderColor: '#A1BDE6',
                tension: 0,
              },
            ],
          }"
          :options="{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    min: 150,
                    stepSize: 10,
                    userCallback(value, index, values) {
                      return `${value} bpm`
                    },
                  },
                },
              ],
            },
            legend: {
              display: false,
            },
          }"
        />
        <p class="gray500 fw700 font18 mb-3 mt-4">My latest entries</p>
        <div class="bs br8 p12 d-flex align-items-center">
          <template v-if="latestVals.heart">
            <div class="d-flex align-items-center br8 bg-gray100 p-3 font18 gray700">
              <span class="font20 fw700 gray700 mr-1"> {{ latestVals.heart }} </span>
              BPM
            </div>
            <p class="flex-grow-1 ml-3 font12 gray900">On: {{ new Date(latestDate.heart).toDateString().substring(4) }}</p>
            <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp font15" :style="{ color: getPrimary300Color() }" />
            <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300 font15" />
          </template>
          <div v-else class="d-flex align-items-center justify-content-between w-100">
            <p class="mb-0 gray900 font12">You haven’t added any data yet</p>
            <button class="br6 px-3 py-2 font12 fw700 text-white" :style="{ 'background-color': getPrimaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">Add</button>
          </div>
        </div>
      </div>

      <!-- BODY TEMPERATURE -->
      <div class="bs p-4 br8 mt80">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="fw700 font24 gray900">Body Temperature</h4>
          <h5 class="fw700 gray900 font20" v-if="avgVals.temp">Avg. {{ avgVals.temp }}°F</h5>
        </div>
        <LineGraph
          :chart-data="{
            labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            datasets: [
              {
                backgroundColor: 'rgba(200,219,245,0.5)',
                data: [90, 80, 100, 80, 90, 90, 100],
                fill: true,
                borderColor: ['rgba(200,219,245)'],
                pointBackgroundColor: '#A1BDE6',
                pointBorderWidth: 2,
                pointBorderColor: '#A1BDE6',
                tension: 0,
              },
            ],
          }"
          :options="{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    min: 60,
                    stepSize: 10,
                    userCallback(value, index, values) {
                      return `${value}°F`
                    },
                  },
                },
              ],
            },
            legend: {
              display: false,
            },
          }"
        />
        <p class="gray500 fw700 font18 mb-3 mt-4">My latest entries</p>
        <div class="bs br8 p12 d-flex align-items-center">
          <template v-if="latestVals.temp">
            <div class="d-flex align-items-center br8 bg-gray100 p-3 font18 gray700">
              <span class="font20 fw700 gray700 mr-1"> {{ latestVals.temp }} </span>
              °F
            </div>
            <p class="flex-grow-1 ml-3 font12 gray900">On: {{ new Date(latestDate.temp).toDateString().substring(4) }}</p>
            <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp font15" :style="{ color: getPrimary300Color() }" />
            <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300 font15" />
          </template>
          <div v-else class="d-flex align-items-center justify-content-between w-100">
            <p class="mb-0 gray900 font12">You haven’t added any data yet</p>
            <button class="br6 px-3 py-2 font12 fw700 text-white" :style="{ 'background-color': getPrimaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">Add</button>
          </div>
        </div>
      </div>

      <!-- WEIGHT -->
      <div class="bs p-4 br8 mt80">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="fw700 font24 gray900">Weight</h4>
          <h5 class="fw700 gray900 font20" v-if="avgVals.weight">Avg. {{ avgVals.weight }} Lb</h5>
        </div>
        <LineGraph
          :chart-data="{
            labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            datasets: [
              {
                backgroundColor: 'rgba(200,219,245,0.5)',
                data: [160, 140, 180, 140, 160, 160, 180],
                fill: true,
                borderColor: ['rgba(200,219,245)'],
                pointBackgroundColor: '#A1BDE6',
                pointBorderWidth: 2,
                pointBorderColor: '#A1BDE6',
                tension: 0,
              },
            ],
          }"
          :options="{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    min: 100,
                    stepSize: 20,
                    userCallback(value, index, values) {
                      return `${value} Lb`
                    },
                  },
                },
              ],
            },
            legend: {
              display: false,
            },
          }"
        />
        <p class="gray500 fw700 font18 mb-3 mt-4">My latest entries</p>
        <div class="bs br8 p12 d-flex align-items-center">
          <template v-if="latestVals.weight">
            <div class="d-flex align-items-center br8 bg-gray100 p-3 font18 gray700">
              <span class="font20 fw700 gray700 mr-1"> {{ latestVals.weight }} </span>
              LB
            </div>
            <p class="flex-grow-1 ml-3 font12 gray900">On: {{ new Date(latestDate.weight).toDateString().substring(4) }}</p>
            <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp font15" :style="{ color: getPrimary300Color() }" />
            <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300 font15" />
          </template>
          <div v-else class="d-flex align-items-center justify-content-between w-100">
            <p class="mb-0 gray900 font12">You haven’t added any data yet</p>
            <button class="br6 px-3 py-2 font12 fw700 text-white" :style="{ 'background-color': getPrimaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">Add</button>
          </div>
        </div>
      </div>

      <!-- MOOD -->
      <div class="bs p-4 br8 mt80">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="fw700 font24 gray900">Mood</h4>
          <h5 class="fw700 gray900 font20">{{ highestVals.mood }}</h5>
        </div>
        <LineGraph
          :chart-data="{
            labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            datasets: [
              {
                backgroundColor: 'rgba(200,219,245,0.5)',
                data: [2, 2, 3, 1, 3, 2, 3],
                fill: true,
                borderColor: ['rgba(200,219,245)'],
                pointBackgroundColor: '#A1BDE6',
                pointBorderWidth: 2,
                pointBorderColor: '#A1BDE6',
                tension: 0,
              },
            ],
          }"
          :options="{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    stepSize: 1,
                    max: 4,
                    beginAtZero: true,
                    userCallback(value, index, values) {
                      const valueName = ['', 'Bad', 'Okay', 'Good']
                      return valueName[value] || ''
                    },
                  },
                },
              ],
            },
            legend: {
              display: false,
            },
          }"
        />
        <p class="gray500 fw700 font18 mb-3 mt-4">My latest entries</p>
        <div class="bs br8 p12 d-flex align-items-center">
          <template v-if="latestVals.mood">
            <div class="d-flex align-items-center br8 bg-gray100 p-3 font14 gray700 fw700 text-capitalize">
              <img src="../../../assets/emojis/good-32.png" alt="emoji" class="hw48 ar1 mr-1" />
              {{ latestVals.mood }}
            </div>
            <p class="flex-grow-1 ml-3 font12 gray900">On: {{ new Date(latestDate.mood).toDateString().substring(4) }}</p>
            <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp font15" :style="{ color: getPrimary300Color() }" />
            <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300 font15" />
          </template>
          <div v-else class="d-flex align-items-center justify-content-between w-100">
            <p class="mb-0 gray900 font12">You haven’t added any data yet</p>
            <button class="br6 px-3 py-2 font12 fw700 text-white" :style="{ 'background-color': getPrimaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">Add</button>
          </div>
        </div>
      </div>
    </template>

    <!-- MEDICATIONS -->
    <div class="bs p-4 br8 mt80">
      <div class="d-flex align-items-center">
        <h4 class="fw700 font24 gray900">Medication</h4>
        <a-select :size="'large'" class="prof-dovedaily-select ml-3" v-model="selectValues.med">
          <a-select-option value="compliance">Compliance</a-select-option>
          <a-select-option value="effectiveness">Effectiveness</a-select-option>
        </a-select>
        <a-select :size="'large'" class="prof-dovedaily-select ml-3" v-model="effectVals.med" v-if="selectValues.med === 'effectiveness'">
          <a-select-option v-for="medication in medications" :key="medication" :value="medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name">
            {{ medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name }}
          </a-select-option>
        </a-select>
        <h5 v-if="activeFilterTab !== 'Day' && selectValues.med !== 'effectiveness'" class="fw700 gray900 font20 ml-auto">{{ highestVals.med }}</h5>
      </div>
      <LineGraph
        v-if="activeFilterTab !== 'Day'"
        :chart-data="{
          labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          datasets: [
            {
              backgroundColor: 'rgba(200,219,245,0.5)',
              data: [2, 2, 3, 1, 3, 2, 3],
              fill: true,
              borderColor: ['rgba(200,219,245)'],
              pointBackgroundColor: '#A1BDE6',
              pointBorderWidth: 2,
              pointBorderColor: '#A1BDE6',
              tension: 0,
            },
          ],
        }"
        :options="{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  stepSize: 1,
                  max: 4,
                  beginAtZero: true,
                  userCallback(value, index, values) {
                    const valueName = ['', 'Not taken', 'Partially taken', 'Fully taken']
                    return valueName[value] || ''
                  },
                },
              },
            ],
          },
          legend: {
            display: false,
          },
        }"
      />
      <p class="gray500 fw700 font18 mb-3 mt-4">My latest entries</p>
      <template v-if="medications && medications.length">
        <div class="eachBox bs br8 mb-3" v-for="medication in medications" :key="medication.id">
          <div class="d-flex align-items-center">
            <div :class="`dot bg-${getEffectColor(medication.effectiveness)}`"></div>
            <p class="ml-1 mb-0 font16 fw700 newColor">
              {{ medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name }}
            </p>
            <!-- <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1 ml-2">Fully Taken</div> -->
            <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp ml-auto" :style="{ color: getPrimary300Color() }" />
            <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300" />
          </div>
          <div class="d-flex align-items-center mt-3">
            <p class="mb-0 mr-2 font12 gray900" style="min-width: 70px">Side Effects:</p>
            <div class="d-flex align-items-center flex-wrap gap8" v-if="medication.side_effect && medication.side_effect.length">
              <div class="eachSideEffect d-flex" v-for="sideEffect in medication.side_effect" :key="sideEffect">
                <p class="mr-3 mb-0 gray900 font12">
                  {{ sideEffect.display_name }}
                </p>
                <p :class="`${getSideEffectColor(sideEffect.effectiveness)} mb-0 fw700 font12`">
                  {{ getSideEffectLevel(sideEffect.effectiveness) }}
                </p>
              </div>
            </div>
            <template v-else>
              <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1">None</div>
            </template>
          </div>
          <div class="d-flex align-items-center mt-3">
            <p class="mb-0 font12 gray900">
              Effectiveness:
              <span :class="`${getEffectColor(medication.effectiveness)} fw700 font12 ml-3`">
                {{ getEffectLevel(medication.effectiveness) }}
              </span>
            </p>
          </div>
          <div class="d-flex align-items-center mt-3">
            <p class="mb-0 font12 gray900">From: {{ new Date(medication.treatment_duration[0][0]).toDateString().substring(4) }}</p>
            <p class="mb-0 font12 gray900 ml-3">To: {{ medication.treatment_duration[0][1] ? new Date(medication.treatment_duration[0][1]).toDateString().substring(4) : "Still Taking" }}</p>
            <p class="mb-0 font12 fw700 red300 ml-auto" v-if="medication.treatment_duration[0][1] && new Date(medication.treatment_duration[0][1]) < new Date()">Stopped</p>
          </div>
        </div>
        <div class="cp bg-gray100 p-2 br8 font14 fw700 text-center" :style="{ color: getPrimaryColor() }" v-if="totalVals.med > 3" @click="viewMoreClick('med')">View {{ totalVals.med - 3 }} more</div>
      </template>
      <template v-else>
        <div v-if="activeFilterTab !== 'Day'" class="d-flex align-items-center justify-content-between w-100 br8 p-3 bs">
          <p class="mb-0 gray900 font12">You haven’t added any data yet</p>
          <button class="br6 px-3 py-2 font12 fw700 text-white" :style="{ 'background-color': getPrimaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">Add</button>
        </div>
        <div v-else class="d-flex align-items-center flex-column w-100 br8 p-3 bg-gray100">
          <p class="mb-3 gray700 font16 fw700">You have not updated your medication yet.</p>
          <button class="br6 px-3 py-2 font12 fw700 text-white" :style="{ 'background-color': getSecondaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">Update</button>
        </div>
      </template>
    </div>

    <!-- ACTIVITIES -->
    <div class="bs p-4 br8 mt80">
      <div class="d-flex align-items-center">
        <h4 class="fw700 font24 gray900">Activities</h4>
        <a-select :size="'large'" class="prof-dovedaily-select ml-3" v-model="selectValues.act">
          <a-select-option value="compliance">Compliance</a-select-option>
          <a-select-option value="effectiveness">Effectiveness</a-select-option>
        </a-select>
        <a-select :size="'large'" class="prof-dovedaily-select ml-3" v-model="effectVals.act" v-if="selectValues.act === 'effectiveness'">
          <a-select-option v-for="medication in activities" :key="medication" :value="medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name">
            {{ medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name }}
          </a-select-option>
        </a-select>
        <h5 class="fw700 gray900 font20 ml-auto" v-if="activeFilterTab !== 'Day' && selectValues.act !== 'effectiveness'">{{ highestVals.act }}</h5>
      </div>
      <LineGraph
        v-if="activeFilterTab !== 'Day'"
        :chart-data="{
          labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          datasets: [
            {
              backgroundColor: 'rgba(200,219,245,0.5)',
              data: [2, 2, 1, 1, 2, 2, 1],
              fill: true,
              borderColor: ['rgba(200,219,245)'],
              pointBackgroundColor: '#A1BDE6',
              pointBorderWidth: 2,
              pointBorderColor: '#A1BDE6',
              tension: 0,
            },
          ],
        }"
        :options="{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  stepSize: 1,
                  max: 3,
                  beginAtZero: true,
                  userCallback(value, index, values) {
                    const valueName = ['', 'Not as per plan', 'As per plan']
                    return valueName[value] || ''
                  },
                },
              },
            ],
          },
          legend: {
            display: false,
          },
        }"
      />
      <p class="gray500 fw700 font18 mb-3 mt-4">My latest entries</p>
      <template v-if="activities && activities.length">
        <div class="eachBox bs br8 mb-3" v-for="medication in activities" :key="medication.id">
          <div class="d-flex align-items-center">
            <div :class="`dot bg-${getEffectColor(medication.effectiveness)}`"></div>
            <p class="ml-1 mb-0 font16 fw700 newColor">
              {{ medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name }}
            </p>
            <!-- <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1 ml-2">Fully Taken</div> -->
            <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp ml-auto" :style="{ color: getPrimary300Color() }" />
            <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300" />
          </div>
          <div class="d-flex align-items-center mt-3">
            <p class="mb-0 mr-2 font12 gray900" style="min-width: 70px">Side Effects:</p>
            <div class="d-flex align-items-center flex-wrap gap8" v-if="medication.side_effect && medication.side_effect.length">
              <div class="eachSideEffect d-flex" v-for="sideEffect in medication.side_effect" :key="sideEffect">
                <p class="mr-3 mb-0 gray900 font12">
                  {{ sideEffect.display_name }}
                </p>
                <p :class="`${getSideEffectColor(sideEffect.effectiveness)} mb-0 fw700 font12`">
                  {{ getSideEffectLevel(sideEffect.effectiveness) }}
                </p>
              </div>
            </div>
            <template v-else>
              <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1">None</div>
            </template>
          </div>
          <div class="d-flex align-items-center mt-3">
            <p class="mb-0 font12 gray900">
              Effectiveness:
              <span :class="`${getEffectColor(medication.effectiveness)} fw700 font12 ml-3`">
                {{ getEffectLevel(medication.effectiveness) }}
              </span>
            </p>
          </div>
          <div class="d-flex align-items-center mt-3">
            <p class="mb-0 font12 gray900">From: {{ new Date(medication.treatment_duration[0][0]).toDateString().substring(4) }}</p>
            <p class="mb-0 font12 gray900 ml-3">To: {{ medication.treatment_duration[0][1] ? new Date(medication.treatment_duration[0][1]).toDateString().substring(4) : "Still Doing" }}</p>
            <p class="mb-0 font12 fw700 red300 ml-auto" v-if="medication.treatment_duration[0][1] && new Date(medication.treatment_duration[0][1]) < new Date()">Stopped</p>
          </div>
        </div>
        <div class="cp bg-gray100 p-2 br8 font14 fw700 text-center" :style="{ color: getPrimaryColor() }" v-if="totalVals.act > 3" @click="viewMoreClick('act')">View {{ totalVals.act - 3 }} more</div>
      </template>
      <template v-else>
        <div v-if="activeFilterTab !== 'Day'" class="d-flex align-items-center justify-content-between w-100 br8 p-3 bs">
          <p class="mb-0 gray900 font12">You haven’t added any data yet</p>
          <button class="br6 px-3 py-2 font12 fw700 text-white" :style="{ 'background-color': getPrimaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">Add</button>
        </div>
        <div v-else class="d-flex align-items-center flex-column w-100 br8 p-3 bg-gray100">
          <p class="mb-3 gray700 font16 fw700">You have not updated your activities yet.</p>
          <button class="br6 px-3 py-2 font12 fw700 text-white" :style="{ 'background-color': getSecondaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">Update</button>
        </div>
      </template>
    </div>

    <!-- NUTRITION -->
    <div class="bs p-4 br8 mt80">
      <div class="d-flex align-items-center">
        <h4 class="fw700 font24 gray900">Nutrition</h4>
        <a-select :size="'large'" class="prof-dovedaily-select ml-3" v-model="selectValues.nut">
          <a-select-option value="compliance">Compliance</a-select-option>
          <a-select-option value="effectiveness">Effectiveness</a-select-option>
        </a-select>
        <a-select :size="'large'" class="prof-dovedaily-select ml-3" v-model="effectVals.nut" v-if="selectValues.nut === 'effectiveness'">
          <a-select-option v-for="medication in nutritions" :key="medication" :value="medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name">
            {{ medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name }}
          </a-select-option>
        </a-select>
        <h5 class="fw700 gray900 font20 ml-auto" v-if="activeFilterTab !== 'Day' && selectValues.nut !== 'effectiveness'">{{ highestVals.nut }}</h5>
      </div>
      <LineGraph
        v-if="activeFilterTab !== 'Day'"
        :chart-data="{
          labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          datasets: [
            {
              backgroundColor: 'rgba(200,219,245,0.5)',
              data: [2, 2, 1, 1, 2, 2, 1],
              fill: true,
              borderColor: ['rgba(200,219,245)'],
              pointBackgroundColor: '#A1BDE6',
              pointBorderWidth: 2,
              pointBorderColor: '#A1BDE6',
              tension: 0,
            },
          ],
        }"
        :options="{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  stepSize: 1,
                  max: 3,
                  beginAtZero: true,
                  userCallback(value, index, values) {
                    const valueName = ['', 'Not as per plan', 'As per plan']
                    return valueName[value] || ''
                  },
                },
              },
            ],
          },
          legend: {
            display: false,
          },
        }"
      />
      <p class="gray500 fw700 font18 mb-3 mt-4">My latest entries</p>
      <template v-if="nutritions && nutritions.length">
        <div class="eachBox bs br8 mb-3" v-for="medication in nutritions" :key="medication.id">
          <div class="d-flex align-items-center">
            <div :class="`dot bg-${getEffectColor(medication.effectiveness)}`"></div>
            <p class="ml-1 mb-0 font16 fw700 newColor">
              {{ medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name }}
            </p>
            <!-- <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1 ml-2">Fully Taken</div> -->
            <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp ml-auto" :style="{ color: getPrimary300Color() }" />
            <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300" />
          </div>
          <div class="d-flex align-items-center mt-3">
            <p class="mb-0 mr-2 font12 gray900" style="min-width: 70px">Side Effects:</p>
            <div class="d-flex align-items-center flex-wrap gap8" v-if="medication.side_effect && medication.side_effect.length">
              <div class="eachSideEffect d-flex" v-for="sideEffect in medication.side_effect" :key="sideEffect">
                <p class="mr-3 mb-0 gray900 font12">
                  {{ sideEffect.display_name }}
                </p>
                <p :class="`${getSideEffectColor(sideEffect.effectiveness)} mb-0 fw700 font12`">
                  {{ getSideEffectLevel(sideEffect.effectiveness) }}
                </p>
              </div>
            </div>
            <template v-else>
              <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1">None</div>
            </template>
          </div>
          <div class="d-flex align-items-center mt-3">
            <p class="mb-0 font12 gray900">
              Effectiveness:
              <span :class="`${getEffectColor(medication.effectiveness)} fw700 font12 ml-3`">
                {{ getEffectLevel(medication.effectiveness) }}
              </span>
            </p>
          </div>
          <div class="d-flex align-items-center mt-3">
            <p class="mb-0 font12 gray900">From: {{ new Date(medication.treatment_duration[0][0]).toDateString().substring(4) }}</p>
            <p class="mb-0 font12 gray900 ml-3">To: {{ medication.treatment_duration[0][1] ? new Date(medication.treatment_duration[0][1]).toDateString().substring(4) : "Still Doing" }}</p>
            <p class="mb-0 font12 fw700 red300 ml-auto" v-if="medication.treatment_duration[0][1] && new Date(medication.treatment_duration[0][1]) < new Date()">Stopped</p>
          </div>
        </div>
        <div class="cp bg-gray100 p-2 br8 font14 fw700 text-center" :style="{ color: getPrimaryColor() }" v-if="totalVals.nut > 3" @click="viewMoreClick('nut')">View {{ totalVals.nut - 3 }} more</div>
      </template>
      <template v-else>
        <div v-if="activeFilterTab !== 'Day'" class="d-flex align-items-center justify-content-between w-100 br8 p-3 bs">
          <p class="mb-0 gray900 font12">You haven’t added any data yet</p>
          <button class="br6 px-3 py-2 font12 fw700 text-white" :style="{ 'background-color': getPrimaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">Add</button>
        </div>
        <div v-else class="d-flex align-items-center flex-column w-100 br8 p-3 bg-gray100">
          <p class="mb-3 gray700 font16 fw700">You have not updated your nutrition yet.</p>
          <button class="br6 px-3 py-2 font12 fw700 text-white" :style="{ 'background-color': getSecondaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })">Update</button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import LineGraph from "./LineGraph.vue"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import axios from "axios"

import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import moment from "moment"

// import dayjs from "dayjs"
// import "dayjs/locale/en_GB"
// import "dayjs/plugin/updateLocale"

// dayjs.updateLocale("en_gb", {
//   weekStart: 0,
// })

// import moment from "moment"
// import 'moment/locale/de';
// moment.locale('de')
// moment.updateLocale("en", { week: { dow: 1 } })

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PatientDovedaily",
  components: { LineGraph, DatePicker },
  async created() {
    console.warn("PatientDovedaily.vue is created")

    // this.gFitAllowed = JSON.parse(localStorage.getItem("gFitInfo") || '{"allowed":false}').allowed

    this.checkGFitSync()
    this.checkFitbitSync()

    const response = await UserRepository.getDovedaily(this.currentCircle.id)
    this.dovedailyUpdatedAt = response.data.data[0] && response.data.data[0].last_updated_at

    // const medResponse = await UserRepository.getTreatments(this.authUser.user, this.currentCircle.id, "Medication", !this.viewMore.med ? 1 : null, !this.viewMore.med ? 3 : null)
    // this.medications = medResponse.data.data || []
    // this.totalVals.med = medResponse.data.paginator.total_count

    // const activityResponse = await UserRepository.getTreatments(this.authUser.user, this.currentCircle.id, "Activity", !this.viewMore.act ? 1 : null, !this.viewMore.act ? 3 : null)
    // this.activities = activityResponse.data.data || []
    // this.totalVals.act = activityResponse.data.paginator.total_count

    // const nutritionResponse = await UserRepository.getTreatments(this.authUser.user, this.currentCircle.id, "Nutrition", !this.viewMore.nut ? 1 : null, !this.viewMore.nut ? 3 : null)
    // this.nutritions = nutritionResponse.data.data || []
    // this.totalVals.nut = nutritionResponse.data.paginator.total_count

    // await this.getTreatmentList("med")
    // await this.getTreatmentList("nut")
    // await this.getTreatmentList("act")

    // console.log("this.$route:", this.$route)
    console.log("this.$route.query.type:", this.$route.query.type)
    console.log("this.$route.query.code:", this.$route.query.code)

    // if (this.$route.query && this.$route.query.type && this.$route.query.type === "gfit" && this.$route.query.code) {
    //   const tokenRes = await axios.post("https://oauth2.googleapis.com/token", {
    //     client_id: "101951622305-r97l0t8dvq817olgmshsrjrekmuna8k1.apps.googleusercontent.com",
    //     client_secret: "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",
    //     code: this.$route.query.code,
    //     grant_type: "authorization_code",
    //     redirect_uri: `${window.location.origin + window.location.pathname}?type=gfit`,
    //   })
    //   console.log("token ->", tokenRes.data)
    // }

    // this.connectFitBit()
    // if (this.$route.query.code) {
    //   localStorage.setItem("gFitInfo", JSON.stringify({ allowed: true, auth_code: this.$route.query.code }))
    //   return
    // }

    if (!this.$route.query.type) return
    if (this.$route.query.type === "gfit") {
      this.connectGFit(this.$route.query.code)
      return
    }
    if (this.$route.query.type === "fitbit") {
      this.connectFitBit(this.$route.query.code)
      return
    }
  },
  mounted() {
    console.warn("PatientDovedaily.vue is mounted")
  },
  data() {
    return {
      // oneDayValue: { sleep: "", mood: "", heart: 0, sleep: 0, temp: 0, weight: 0 },
      dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      xAxisLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      graphDataLoading: false,
      oneDayData: { mood: "" },
      dovedailyUpdatedAt: null,
      activeFilterTab: "Day",
      filterTrends: ["Day", "Week", "Month", "Year"],
      selectValues: { med: "compliance", act: "compliance", nut: "compliance" },
      effectVals: { med: undefined, act: undefined, nut: undefined },
      // startDate: null,
      // endDate: null,
      selectedDate: null,
      selectedNewDate: null,
      avgVals: { heart: 0, sleep: 0, temp: 0, weight: 0 },
      highestVals: { med: "", nut: "", act: "", mood: "" },
      latestVals: { heart: 0, sleep: 0, temp: 0, weight: 0, mood: 0 },
      latestDate: { heart: null, sleep: null, temp: null, weight: null, mood: null },
      heartRateVals: [],
      sleepVals: [],
      bodyTempVals: [],
      weightVals: [],
      nutVals: [],
      medVals: [],
      actVals: [],
      moodVals: [],
      medications: [],
      activities: [],
      nutritions: [],
      viewMore: { med: false, nut: false, act: false },
      totalVals: { med: 0, act: 0, nut: 0 },
      gFitAllowed: false,
      fitbitAllowed: false,
      gFitAuthCode: "",
      fitbitAuthCode: "",
    }
  },
  watch: {
    "$route.query": {
      handler(v) {
        console.log("watching $route.query:", v)
      },
    },
    async selectedDate(v) {
      // console.warn("watching selectedDate")
      this.resetVals()

      if (v) {
        // console.log("selectedDate:", v)
        // console.log("selectedDate as Date:", new Date(v))

        const dateFormat = new Date(v)

        let startDate = ""
        let endDate = ""

        switch (this.activeFilterTab) {
          case "Week":
            this.xAxisLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
            // this.xAxisLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
            startDate = new Date(dateFormat.getFullYear(), dateFormat.getMonth(), dateFormat.getDate() - dateFormat.getDay())
            endDate = new Date(dateFormat.getFullYear(), dateFormat.getMonth(), dateFormat.getDate() + 6 - dateFormat.getDay())
            break
          case "Month":
            startDate = new Date(dateFormat.getFullYear(), dateFormat.getMonth(), 1)
            endDate = new Date(dateFormat.getFullYear(), dateFormat.getMonth() + 1, 0)
            this.xAxisLabels = Array.from({ length: this.getDaysInMonth(dateFormat.getFullYear(), dateFormat.getMonth()) }).map((_, i) => (i + 1).toLocaleString().padStart(2, "0"))
            break
          case "Year":
            startDate = new Date(dateFormat.getFullYear(), 0, 1)
            endDate = new Date(dateFormat.getFullYear(), 12, 0)
            this.xAxisLabels = this.monthNames
            break
          default:
            this.xAxisLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
        }

        // console.log("startDate:", startDate)
        // console.log("endDate:", endDate)

        if (this.activeFilterTab === "Day") {
          const res = await UserRepository.getProfDovedaily(this.currentCircle.id, new Date(v).toISOString().substring(0, 10), new Date(v).toISOString().substring(0, 10))
          // console.log("res:", res.data)
          this.avgVals.sleep = res.data.average_sleep || 0
          this.avgVals.heart = res.data.average_heart_rate || 0
          this.avgVals.temp = res.data.average_temperature || 0
          this.avgVals.weight = res.data.average_weight || 0
          this.oneDayData = res.data.data[0]
        } else if (this.activeFilterTab === "Year") {
          const res = await UserRepository.getProfDovedaily(this.currentCircle.id, null, null, dateFormat.getFullYear())
          // console.log("res:", res.data)
        }
      }
      // console.log("-----------------------")
    },
    async startDate(v) {
      if (this.activeFilterTab === "Day" && v) {
        this.resetVals()
        const res = await UserRepository.getProfDovedaily(this.currentCircle.id, new Date(v).toISOString().substring(0, 10), new Date(v).toISOString().substring(0, 10))
        // console.log("res:", res.data)
        this.avgVals.sleep = res.data.average_sleep || 0
        this.avgVals.heart = res.data.average_heart_rate || 0
        this.avgVals.temp = res.data.average_temperature || 0
        this.avgVals.weight = res.data.average_weight || 0
        this.oneDayData = res.data.data[0]
      } else {
        // this.changeEndDate()
      }
    },
    // activeFilterTab() {
    //   if (this.startDate) {
    //     this.changeEndDate()
    //   }
    // },
    async endDate(v) {
      if (v) {
        try {
          this.resetVals()
          this.graphDataLoading = true
          const res = await UserRepository.getProfDovedaily(this.currentCircle.id, new Date(this.startDate).toISOString().substring(0, 10), new Date(v).toISOString().substring(0, 10))
          // console.log("res.data:", res.data)

          this.avgVals.sleep = res.data.average_sleep || 0
          this.avgVals.heart = res.data.average_heart_rate || 0
          this.avgVals.temp = res.data.average_temperature || 0
          this.avgVals.weight = res.data.average_weight || 0
          // console.log("avg:", this.avgVals)

          res.data.data.forEach(data => {
            this.heartRateVals.push(data.heart_rate || 0)
            this.sleepVals.push(data.sleep || 0)
            this.bodyTempVals.push(data.temperature || 0)
            this.weightVals.push(data.weight || 0)
            this.nutVals.push(data.nutrition || 0)
            this.medVals.push(data.medication || 0)
            this.actVals.push(data.activity || 0)
            this.moodVals.push(data.mood || "")
          })
          // console.log("heart:", this.heartRateVals)
          // console.log("sleep:", this.sleepVals)
          // console.log("temp:", this.bodyTempVals)
          // console.log("weight:", this.weightVals)
          // console.log("nut:", this.nutVals)
          // console.log("med:", this.medVals)
          // console.log("act:", this.actVals)
          // console.log("mood:", this.moodVals)

          this.highestVals.med = `${+res.data.highest_medication_percentage_value.toFixed(2)}% ${res.data.highest_medication_percentage_choice || ""}`
          this.highestVals.act = `${+res.data.highest_activity_percentage_value.toFixed(2)}% ${res.data.highest_activity_percentage_choice || ""}`
          this.highestVals.nut = `${+res.data.highest_nutrition_percentage_value.toFixed(2)}% ${res.data.highest_nutrition_percentage_choice || ""}`
          this.highestVals.mood = `${+res.data.highest_mood_percentage.toFixed(2)}% ${res.data.highest_mood || ""}`
          // console.log("highest:", this.highestVals)

          if (res.data.user_heart_rate_latest) {
            this.latestVals.heart = res.data.user_heart_rate_latest.heart_rate
            this.latestDate.heart = new Date(res.data.user_heart_rate_latest.created_at)
          }
          if (res.data.user_temperature_latest) {
            this.latestVals.temp = res.data.user_temperature_latest.temperature
            this.latestDate.temp = new Date(res.data.user_temperature_latest.created_at)
          }
          if (res.data.user_weight_latest) {
            this.latestVals.weight = res.data.user_weight_latest.weight
            this.latestDate.weight = new Date(res.data.user_weight_latest.created_at)
          }
          if (res.data.user_mood_latest) {
            this.latestVals.mood = res.data.user_mood_latest.mood
            this.latestDate.mood = new Date(res.data.user_mood_latest.created_at)
          }
          if (res.data.user_sleep_latest) {
            this.latestVals.sleep = res.data.user_sleep_latest.sleep
            this.latestDate.sleep = new Date(res.data.user_sleep_latest.created_at)
          }
          // console.log("latest Values:", this.latestVals)
          // console.log("latest Dates:", this.latestDate)

          this.xAxisLabels = []
          switch (this.activeFilterTab) {
            case "Week":
              this.xAxisLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
              break
            case "Month":
              this.xAxisLabels = Array.from({ length: this.getDaysInMonth(new Date(v).getFullYear(), new Date(v).getMonth()) }).map((_, i) => i + 1)
              break
            case "Year":
              this.xAxisLabels = this.monthNames
              break
            default:
              this.xAxisLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
          }
          this.graphDataLoading = false
        } catch (e) {
          this.graphDataLoading = false
          this.$notification.error({ message: "Error fetching data", description: "Try again later." })
        }
      }
    },
    async selectedNewDate(v) {
      // to get start of week, minus .getDay()
      // console.log({ v })

      const dateFormat = new Date(v)
      // console.log({ dateFormat })
      // console.log("dateFormat.toISOString:", dateFormat.toISOString())
      // console.log("moment(dateFormat).toISOString(true):", moment(dateFormat).toISOString(true))
      // console.log("moment(dateFormat).toISOString(false):", moment(dateFormat).toISOString(false))

      var startDate = dateFormat
      var endDate = dateFormat

      switch (this.activeFilterTab) {
        case "Week":
          this.xAxisLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
          // this.xAxisLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
          startDate = new Date(dateFormat.getFullYear(), dateFormat.getMonth(), dateFormat.getDate() - dateFormat.getDay())
          endDate = new Date(dateFormat.getFullYear(), dateFormat.getMonth(), dateFormat.getDate() + 6 - dateFormat.getDay())
          break
        case "Month":
          startDate = new Date(dateFormat.getFullYear(), dateFormat.getMonth(), 1)
          endDate = new Date(dateFormat.getFullYear(), dateFormat.getMonth() + 1, 0)
          this.xAxisLabels = Array.from({ length: this.getDaysInMonth(dateFormat.getFullYear(), dateFormat.getMonth()) }).map((_, i) => (i + 1).toLocaleString().padStart(2, "0"))
          break
        case "Year":
          startDate = new Date(dateFormat.getFullYear(), 0, 1)
          endDate = new Date(dateFormat.getFullYear(), 12, 0)
          this.xAxisLabels = this.monthNames
          break
        // case "Day":
        default:
          this.xAxisLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
      }

      const res = await UserRepository.getProfDovedaily(
        this.currentCircle.id,
        moment(startDate)
          .toISOString(true)
          .substring(0, 10),
        moment(endDate)
          .toISOString(true)
          .substring(0, 10)
      )
      console.log("res.data:", res.data)

      if (this.activeFilterTab === "Day" && v) {
        this.avgVals.sleep = res.data.average_sleep || 0
        this.avgVals.heart = res.data.average_heart_rate || 0
        this.avgVals.temp = res.data.average_temperature || 0
        this.avgVals.weight = res.data.average_weight || 0
        this.oneDayData = res.data.data[0]
      }
    },
  },
  methods: {
    async connectFitBit(code) {
      const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
      const res = await this.$http.post(`${process.env.BASE_API_URL}/dovemedfitbit/`, { auth_code: code, scopes: ["activity", "sleep", "weight", "heartbeat"] }, { headers })
      // console.log({ res })
      // console.log("res.data:", res.data)
      await this.$http.post(`${process.env.BASE_API_URL}/dovemedfitbitdata/`, { date: moment().format("YYYY-MM-DD") }, { headers })
    },
    async connectGFit(code) {
      try {
        const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
        await this.$http.post(
          `${process.env.BASE_API_URL}/dovedailygooglefit/`,
          // `${process.env.BASE_API_URL}/dovemedgooglefit/`,
          {
            auth_code: code,
            scopes: [
              "https://www.googleapis.com/auth/fitness.activity.read",
              "https://www.googleapis.com/auth/fitness.sleep.read",
              "https://www.googleapis.com/auth/fitness.heart_rate.read",
              "https://www.googleapis.com/auth/fitness.body_temperature.read",
              "https://www.googleapis.com/auth/fitness.body.read",
            ],
          },
          { headers }
        )
        await this.$http.post(`${process.env.BASE_API_URL}/dovedailygooglefitdata/`, { date: moment().format("YYYY-MM-DD") }, { headers })
      } catch (e) {}
    },
    async checkGFitSync() {
      try {
        const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
        const res = await this.$http.get(`${process.env.BASE_API_URL}/dovemedgooglefit/`, { headers })
        // this.gFitAllowed = res.data.message === "True"
      } catch (e) {
        this.$notification.error({ message: "An error occured", description: "Could not fetch data related to gfit device synchronization. Try again." })
        console.log(e)
      }
    },
    async checkFitbitSync() {
      try {
        const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
        const res = await this.$http.get(`${process.env.BASE_API_URL}/dovemedfitbit/`, { headers })
        // this.fitbitAllowed = res.data.message === "True"
      } catch (e) {
        this.$notification.error({ message: "An error occured", description: "Could not fetch data related to fitbit device synchronization. Try again." })
        console.log(e)
      }
    },
    handleDateChange(date, dateString) {
      console.warn("handleDateChange()")
      console.log("date:", date)
      console.log("dateString:", dateString)
      // switch (this.activeFilterTab) {
      //   case "Week":
      //     this.xAxisLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
      //     break
      //   case "Month":
      //     this.xAxisLabels = Array.from({ length: this.getDaysInMonth(new Date(this.selectedDate).getFullYear(), new Date(this.selectedDate).getMonth()) }).map((_, i) => i + 1)
      //     break
      //   case "Year":
      //     this.xAxisLabels = this.monthNames
      //     break
      //   default:
      //     this.xAxisLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
      // }
    },
    getTypeName(name) {
      switch (name) {
        case "med":
          return "Medication"
        case "act":
          return "Activity"
        case "nut":
          return "Nutrition"
        default:
          return ""
      }
    },
    async viewMoreClick(type) {
      if (this.totalVals[type] < 4) {
        return
      }
      this.viewMore[type] = true
      await this.getTreatmentList(type)
    },
    async getTreatmentList(type) {
      const response = await UserRepository.getTreatments(this.authUser.user, this.currentCircle.id, this.getTypeName(type), !this.viewMore[type] ? 1 : null, !this.viewMore[type] ? 3 : null)
      if (!this.viewMore[type]) {
        this.totalVals[type] = response.data && response.data.paginator ? response.data.paginator.total_count : 0
      }
      switch (type) {
        case "med":
          this.medications = response.data.data || []
          break
        case "act":
          this.activities = response.data.data || []
          break
        case "nut":
          this.nutritions = response.data.data || []
          break
      }
    },
    resetVals() {
      this.selectValues = { med: "compliance", act: "compliance", nut: "compliance" }
      this.effectVals = { med: undefined, act: undefined, nut: undefined }
      this.avgVals = { heart: 0, sleep: 0, temp: 0, weight: 0 }
      this.highestVals = { med: "", nut: "", act: "", mood: "" }
      this.latestVals = { heart: 0, sleep: 0, temp: 0, weight: 0 }
      this.latestDate = { heart: null, sleep: null, temp: null, weight: null }
      this.heartRateVals = []
      this.sleepVals = []
      this.bodyTempVals = []
      this.weightVals = []
      this.nutVals = []
      this.medVals = []
      this.actVals = []
      this.moodVals = []
      // this.medications = []
      // this.activities = []
      // this.nutritions = []
    },
    // changeEndDate() {
    //   if (!this.startDate) {
    //     this.endDate = mull
    //   }
    //   switch (this.activeFilterTab) {
    //     case "Year":
    //       this.endDate = this.moment(this.startDate)
    //         .add(1, "years")
    //         .subtract(1, "days")
    //       return
    //     case "Month":
    //       this.endDate = this.moment(this.startDate)
    //         .add(1, "months")
    //         .subtract(1, "days")
    //       return
    //     case "Week":
    //       this.endDate = this.moment(this.startDate)
    //         .add(1, "weeks")
    //         .subtract(1, "days")
    //       return
    //   }
    // },
    handleSync(device) {
      switch (device) {
        case "apple":
          this.$notification.info({ message: "Coming Soon", description: "..." })
          return
        case "google":
          if (this.$route.query.code || this.gFitAllowed) {
            return
          }
          window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/fitness.activity.read+https://www.googleapis.com/auth/fitness.body.read+https://www.googleapis.com/auth/fitness.body_temperature.read+https://www.googleapis.com/auth/fitness.heart_rate.read+https://www.googleapis.com/auth/fitness.sleep.read&access_type=offline&include_granted_scopes=true&state=state_parameter_passthrough_value&redirect_uri=${window
            .location.origin + window.location.pathname}?type=gfit&response_type=code&client_id=101951622305-r97l0t8dvq817olgmshsrjrekmuna8k1.apps.googleusercontent.com&prompt=consent`
          return
        case "fitbit":
          window.location = `https://www.fitbit.com/oauth2/authorize?response_type=code&client_id=23RCYF&redirect_uri=${window.location.origin +
            window.location.pathname}?type=fitbit&scope=activity%20heartrate%20location%20nutrition%20oxygen_saturation%20profile%20respiratory_rate%20settings%20sleep%20social%20temperature%20weight`
          return
      }
    },
    getSideEffectColor(e) {
      switch (e) {
        case 0:
        case "0":
          return "success500"
        case 50:
        case "50":
          return "warning500"
        case 100:
        case "100":
          return "error500"
      }
    },
    getEffectColor(e) {
      switch (e) {
        case null:
          return "gray400"
        case 0:
        case "0":
          return "error500"
        case 50:
        case "50":
          return "warning500"
        case 100:
        case "100":
          return "success500"
      }
    },
    getEffectLevel(e) {
      switch (e) {
        case null:
          return "Not specified"
        case 0:
        case "0":
          return "Not effective"
        case 50:
        case "50":
          return "Somewhat effective"
        case 100:
        case "100":
          return "Very effective"
      }
    },
    getSideEffectLevel(e) {
      switch (e) {
        case 0:
        case "0":
          return "Mild"
        case 50:
        case "50":
          return "Moderate"
        case 100:
        case "100":
          return "Severe"
      }
    },
    getMaxPlus(arr, step) {
      return Math.max(...arr) + step
    },
    getMinMinus(arr, step) {
      return Math.min(...arr) - step
    },
    disabledDate(current) {
      return current > new Date()
      // return current > new Date() || current < this.moment(this.startDate)
    },
    getDaysInMonth(year, month) {
      return new Date(year, month + 1, 0).getDate()
    },
  },
}
</script>

<style lang="scss" scoped>
.bs {
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
}
p,
h4,
h5 {
  margin: 0;
}
.device {
  border: 1px solid #e2e8f0;
  justify-content: space-between;
  img {
    @media screen and (max-width: 600px) {
      max-width: 150px;
    }
  }
}
button,
button:hover,
button:focus {
  border: none;
  outline: none;
}
.trans {
  transition: all 0.3s;
}
.eachBox {
  border: 1px solid #e2e8f0;
  padding: 12px;
}
.dot {
  width: 7px;
  height: 7px;
  border-radius: 2px;
  transform: translateY(1px);
}
.eachSideEffect {
  padding: 4px 8px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.newColor {
  color: #585757;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/PatientDovedaily.vue